import C from './C.png';
import BB1 from './BB1.png';
import BB2 from './BB2.png';
import BB3 from './BB2.png';
import BI from './BI.png';
import G from './G.png';
import K1 from './K1.png';
import K2 from './K2.png';
import K3 from './K3.png';
import K4 from './K4.png';
import K5 from './K5.png';
import K6 from './K6.png';
import Kj4 from './Kj4.png';
import Kj5 from './Kj5.png';
import Kj6 from './Kj6.png';
import MR from './MR.png';
import PR from './PR.png';
import V from './V.png';
import BK from './BK.png';
import CP from './CP.png';
import PA from './PA.png';
import SD from './SD.png';
import SP from './SP.png';

export default {
  C,
  BB1,
  BB2,
  BB3,
  BI,
  G,
  K1,
  K2,
  K3,
  K4,
  K5,
  K6,
  Kj4,
  Kj5,
  Kj6,
  MR,
  PR,
  V,
  BK,
  CP,
  PA,
  SD,
  SP,
};
